<template>
  <div>
    <div class="container-fluid landing-container text-center">
      <div class="dashboard-block">
        <h1>Welcome, {{ $user.first_name }}!</h1>
        <div class="row">
          <p class="lead-text">You will be notified once the {{ clientName }} team has verified your profile and then you're good to go!<br/><br/>While you wait download our {{ $starLabel }} app.</p>
          <div class="flex items-center justify-center">
            <a href="https://itunes.apple.com/au/app/pickstar-sports-talent/id1425719956?mt=8" target="_blank" >
              <img alt='Download in App Store' src='https://linkmaker.itunes.apple.com/en-us/badge-lrg.svg?releaseDate=2018-10-06&kind=iossoftware&bubble=ios_apps' style="height: 40px; width: auto; max-width: none;"/>
            </a>
            <a href="https://play.google.com/store/apps/details?id=pickstar.com.au.talent&hl=en_AU" target="_blank" >
              <img alt='Get it on Google Play' src='https://play.google.com/intl/en_us/badges/images/generic/en_badge_web_generic.png' style="height: 60px; width: auto; max-width: none;"/>
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="container-fluid" v-if="clientName === 'Pickstar'">
      <div class="content-list">
        <span class="lead-text">Thanks for signing up with us here at {{ clientName }}! Here are some quick tips on how to get the best out of the {{ clientName }} platform:</span>
        <div v-for="(item, index) in content" :key="index" class="content-list-item">
          <span class="content-list-item__heading">{{ item.heading }}</span><br/>
          <span>{{ item.text }}</span>
        </div>
        <span>Remember you can always contact us if you have any questions!</span>
      </div>
    </div>
    <div class="background-color-container text-center">
      <div class="container-fluid landing-container">
        <h2 class="subheading">How to use {{ clientName }}</h2>
        <div class="iframe-container">
          <iframe src="https://www.youtube.com/embed/XcAPqMAJY0M" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
        </div>
      </div>
    </div>
    <div class="container-fluid landing-container">
      <div class="dashboard-block">
        <h2 class="text-center">Our Hot Tips</h2>
        <ul class="icon-list">
          <li>
            <div class="row display-table" >
              <div class="fa-stack fa-2x display-table" >
                <i class="fa fa-circle fa-stack-2x icon-background-primary"></i>
                <i class="fa fa-pencil fa-stack-1x icon-foreground"></i>
              </div>
              <p>Fill out your profile with as much detail as possible!</p>
            </div>
          </li>
          <li>
            <div class="row display-table" >
              <div class="fa-stack fa-2x display-table" >
                <i class="fa fa-circle fa-stack-2x icon-background-primary"></i>
                <i class="fa fa-video-camera fa-stack-1x icon-foreground"></i>
              </div>
              <p>Add videos to your profile using the youtube embed function!</p>
            </div>
          </li>
          <li>
            <div class="row display-table" >
              <div class="fa-stack fa-2x display-table" >
                <i class="fa fa-circle fa-stack-2x icon-background-primary"></i>
                <i class="fa fa-check fa-stack-1x icon-foreground"></i>
              </div>
              <p>The more active you are, the better your chance of being booked!</p>
            </div>
          </li>
        </ul>
        <div class="button-wrapper">
          <router-link :to="{ name: 'profile.show', params: { id: this.$user.id } }">
            <button class="btn btn-block btn-primary dropdown-toggle" type="button">
              My Profile
            </button>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      content: [
        {
          heading: 'Read the request!',
          text: 'Only apply to requests when you are happy with the budget, there is no negotiation on your end once you hit apply!'
        },
        {
          heading: 'Let us know what you charge',
          text: 'If you do charge a set fee, let us know so that we can push requests at that budget to you'
        },
        {
          heading: 'Check travel & accommodation',
          text: 'Always check whether or not the client will cover accommodation & travel on top of the fee'
        },
        {
          heading: 'Help us get to know you!',
          text: 'Make sure your bio is detailed, engaging & up to date - this is how the client gets to know you!'
        },
        {
          heading: 'Tell the client',
          text: 'Leave comments when you apply to help tell the client why you should be booked'
        },
        {
          heading: 'Engage the client',
          text: 'Make sure these comments are specific to the request & not what is already in your bio! Talent are more likely to be booked when their comment addresses the brief.'
        },
        {
          heading: 'Where are you from?',
          text: 'Let us know where you are based but also if you are willing to travel for requests and if you already travel around Australia'
        },
        {
          heading: 'Payment details',
          text: 'Talent payments are made the Wednesday after your event so make sure to enter your \'payment details\' in your profile!'
        }
      ]
    }
  }
}
</script>
